const formatArticlePublishedAt = (value: string): string => new Date(value).toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
});

export default formatArticlePublishedAt;
